import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { TableRow, TableHead, TableCell, TableBody, Button, Typography } from '@material-ui/core';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import { TableLayout } from '../../containers/Layout';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';

const SingleTransferArrivage = (props) => {
    const dispatch = useDispatch();
    const PRODUCTS = useSelector((state) => state.inventory.products); 
    const [state, setState] = useState({})
    const [details, setDetails] = useState({})
    const [src, setSRC] = useState({})

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const transferData = await dispatch(fetchTransferDetails(props.transfer.id));
                setDetails(transferData);
                if (!isEmpty(transferData.transfer_files)) {
                    transferData.transfer_files.map(file => {
                        console.log('====================================');
                        console.log({ file });
                        console.log('====================================');
                        downloadFile(file.filename);
                    });
                }
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
        
        fetchTransferData();
    }, [dispatch, props.transfer.id]);

    const createProductList = () => {
        return !isEmpty(details) && details.products.map(item => {
            const product = PRODUCTS && PRODUCTS[item.product_id];
            return (
                <TableRow key={item.product_id}>
                    <TableCell>{product?.name || `Product ID: ${item.product_id}`}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                </TableRow>
            );
        });
    };

    const downloadFile = async (path) => {
        try {
            const req = await fetch('/stocks/getPhotos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ path: path }),
                credentials: 'same-origin'
            });
            const src = await req.json();
            console.log(src);
            if (src.error) {
                console.log("[ERROR], fetching file ", src);
                return;
            }
            setState((prevState) => ({
                ...prevState,
                [path]: src.uri,
            }));
        } catch (err) {
            console.log("[ERROR], catch fetching file", err);
        }
    };

    return (
        <SingleTransferTemplate
            shop={props.shop}
            transfer={details}
            notif={props.notif}
            handleCompleteArrivage={props.handleCompleteArrivage}  
            handleUpdateArrivage={props.handleUpdateArrivage}  
            handleUpdateDemand={props.handleUpdateDemand}  
        >
            <TableLayout>
                <TableHead>
                    <TableRow>
                        <TableCell>Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {createProductList()}
                    <TableRow>
                        <TableCell colSpan={2}></TableCell>
                    </TableRow>
                </TableBody>
            </TableLayout>
        </SingleTransferTemplate>
    );
};

export default SingleTransferArrivage;
